export class FileUpload {
	constructor() {
		this.fileID    = 'file';
		this.inputFile = document.getElementById(this.fileID);
		this.labelFile = document.querySelector('label[for="' + this.fileID + '"] span');
		this.labelText = 'Připojit přílohu';

		if(this.inputFile && this.labelFile) {
			this.addEventListener();
		}
	}

	addEventListener() {
		this.inputFile.addEventListener('change', this.changeValue.bind(this));
	}

	changeValue() {
		let fileValue = '';
		let filename  = '';

		if(this.inputFile.files.length > 0) {
			if(this.inputFile.files.length <= 1) {
				fileValue                = this.inputFile.value;
				filename                 = fileValue.split('\\')
													.pop();
				this.labelFile.innerHTML = filename;
			} else {
				filename                 = 'Vybrané soubory: ' + this.inputFile.files.length;
				this.labelFile.innerHTML = filename;
			}
		} else {
			this.labelFile.innerHTML = this.labelText;
		}
	}
}